import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {IconName} from '../../../../atoms/Icon/IconName';
import {FilterDropdown} from '../FilterDropdown';
import type {Props as FilterDropdownBooleanType} from '../FilterDropdownBoolean/FilterDropdownBoolean';
import {
  FilterDropdownBoolean,
  Label as FilterDropdownBooleanLabel,
} from '../FilterDropdownBoolean/FilterDropdownBoolean';

interface Props {
  label: string;
  onToggleFilterContent: (slug: string, isActive: boolean) => void;
  booleanFilters: Array<{
    filter?: Omit<FilterDropdownBooleanType, 'onToggle'> & {
      slug: string;
      icon?: {description: string; url: string};
    };
  }>;
  displayIcon?: IconName;
  onFilterReset: () => void;
  onOpen?: () => void;
  onClose?: () => void;
  className?: string;
  dataTestId?: string;
}

export const FilterDropdownMultipleBoolean: FC<Props> = ({
  label,
  onToggleFilterContent,
  dataTestId = 'filterDropdownMultipleBoolean',
  className,
  booleanFilters,
  onFilterReset,
  onOpen,
  onClose,
  displayIcon,
}) => {
  const activeFilters = booleanFilters.filter(filter => filter.filter?.active);

  return (
    <FilterDropdown
      dataTestId={dataTestId}
      activeCount={activeFilters.length}
      label={label}
      displayIcon={displayIcon}
      displayIconColor={activeFilters.length > 0 ? COLORS.Black : COLORS.Grey1}
      onReset={onFilterReset}
      onClose={onClose}
      onOpen={onOpen}
      showScrollFade={false}
      padContent={false}
      filterContent={
        <Wrapper className={className}>
          {booleanFilters.map(filter => {
            if (!filter.filter) {
              return null;
            }

            const {active, label, sublabel, slug, icon} = filter.filter;

            return (
              <StyledFilterDropdownBoolean
                key={`${dataTestId}-${slug}`}
                active={active}
                label={label}
                onToggle={() => onToggleFilterContent(slug, active)}
                sublabel={sublabel}
                icon={icon}
              />
            );
          })}
        </Wrapper>
      }
    />
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 1rem 0;
`;

const StyledFilterDropdownBoolean = styled(FilterDropdownBoolean)`
  align-items: flex-start;
  border: 0;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  height: auto;
  padding: 1rem 0;

  &:not(:last-child) {
    border-bottom: solid 1px ${COLORS.Grey3};
  }

  ${FilterDropdownBooleanLabel} {
    color: ${COLORS.Black};
    justify-content: space-between;
    width: 100%;
  }
`;
